import { render } from "./CarouselItem.vue?vue&type=template&id=ac1b3668&ts=true"
import script from "./CarouselItem.vue?vue&type=script&lang=ts"
export * from "./CarouselItem.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__